// frontend/src/services/socrates/templateService.js

import { apiService } from '../api';
import { API_ENDPOINTS } from '../../config/constants';

export const templateService = {
  // Get all templates
  getTemplates: async () => {
    try {
      return await apiService.get(API_ENDPOINTS.AGENTS.TEMPLATES.GET_ALL);
    } catch (error) {
      console.error('Error fetching templates:', error);
      throw error;
    }
  },

  // Get template by ID
  getTemplate: async (templateId) => {
    try {
      return await apiService.get(API_ENDPOINTS.AGENTS.TEMPLATES.GET(templateId));
    } catch (error) {
      console.error(`Error fetching template ${templateId}:`, error);
      throw error;
    }
  },

  // Create template
  createTemplate: async (templateData) => {
    try {
      console.log('Template service creating template with data:', {
        enterprise_id: templateData.enterprise_id,
        user_role: templateData.user_role,
        is_system_template: templateData.is_system_template
      });
      
      return await apiService.post(API_ENDPOINTS.AGENTS.TEMPLATES.CREATE, templateData);
    } catch (error) {
      console.error('Error creating template:', error);
      throw error;
    }
  },

  // Update template
  updateTemplate: async (templateId, templateData) => {
    try {
      console.log('Template service updating template with data:', {
        templateId,
        enterprise_id: templateData.enterprise_id,
        user_role: templateData.user_role,
        is_system_template: templateData.is_system_template
      });
      
      return await apiService.put(API_ENDPOINTS.AGENTS.TEMPLATES.UPDATE(templateId), templateData);
    } catch (error) {
      console.error(`Error updating template ${templateId}:`, error);
      throw error;
    }
  },

  // Delete template - FIXED VERSION
  deleteTemplate: async (deletePayload) => {
    try {
      const { templateId, user_role, enterprise_id } = deletePayload;
      
      console.log('Template service deleting template:', {
        templateId,
        userRole: user_role,
        enterpriseId: enterprise_id
      });
      
      // Build the URL with query parameters
      const url = `${API_ENDPOINTS.AGENTS.TEMPLATES.DELETE(templateId)}?user_role=${encodeURIComponent(user_role)}`;
      
      return await apiService.delete(url);
    } catch (error) {
      console.error(`Error deleting template:`, error);
      throw error;
    }
  }
};

export default templateService;